import styled from 'styled-components';

const StyledCloseBubbleButton = styled.button`
  height: 15px;
  width: 15px;
  position: absolute;
  border-radius: 50%;
  color: #fff;
  background-color: #000;
  display: flex;
  align-content: center;
  justify-content: center;
  top: -7px;
  left: -7px;
  font-size: 8px;
  cursor: pointer;
  border: none;
  flex-wrap: wrap;
`;

export default StyledCloseBubbleButton;